/* Cookie consent */
(function () {
    $(function () {
        let $cookieConsent = $("[data-cookie-consent]");

        // accept cookies
        $cookieConsent.find('[data-cookie-consent="accept"]').click(function (event) {
            event.preventDefault();

            accept();
        });

        // deny cookies
        $cookieConsent.find('[data-cookie-consent="deny"]').click(function (event) {
            event.preventDefault();

            deny();
        });

        // close consent banner
        $cookieConsent.find('[data-cookie-consent="close"]').click(function (event) {
            event.preventDefault();

            close();
        });
    });

    function accept() {
        respond(true);
    }

    function deny() {
        respond(false);
    }

    function close() {
        $("[data-cookie-consent]").remove();
    }

    function respond(value) {
        $("[data-cookie-consent]").hide();

        cookieConsent.set(value)
            .then(function (data) {

                // set bGoogle Analytics anonymizeIp value
                if (window.ga) {
                    ga("set", "anonymizeIp", !data.value);
                }

                // reload page to affect cookie settings
                if (data.reload) {
                    location.reload();
                    return;
                }

                // remove consent banner
                $("[data-cookie-consent]").remove();
            })
            .catch(function (response) {
                $("[data-cookie-consent]").show();

                if (!response.responseJSON) {
                    // beAlert(response.statusText, "error");
                    return;
                }

                // beAlert(response.responseJSON.message, "error");
            });
    }
})();
